import Modal from "react-modal";
import styled from "styled-components";
import { ReactComponent as Cross } from "assets/icons/x.svg";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
}

const customStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.75)",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "850px",
    padding: 0,
    maxHeight: "100vh",
    overflow: "auto",
  },
};

const MathModal = ({ isOpen, onClose }: IProps) => {
  return (
    <Modal
      isOpen={isOpen}
      style={customStyles}
      onRequestClose={onClose}
      ariaHideApp={false}
    >
      <CrossWrapper onClick={onClose}>
        <Cross />
      </CrossWrapper>
      <ModalTitle>Hvordan har vi kommet fram til disse tallene?</ModalTitle>
      <ModalContent>
        <span>Slik sammenligner vi strømprisene</span> Sammenligningen omfatter
        spotprisavtaler. Data er hentet fra strømselskapenes nettsider og
        spotpris hentes fra Nord Pool. Et strømselskap kan ha mange ulike
        spotprisavtaler og i de tilfellene har vi valgt ut den spotprisavtalen
        strømselskapet promoterer tydeligst på sin nettside. Skjulte
        strømavtaler, strømavtaler med binding eller andre skjulte gebyrer er
        ikke med i sammenligningen. Vi hentet ut prisen på strømavtalen til de
        ulike strømselskapene den 04.12.2023. Det er den totale kostnaden for
        strømavtalen som blir sammenlignet (spotpris + påslag + månedspris).
        Analysen er basert på gjennomsnittlig spotpris for prissone 1 i
        januar-mai 2023. Sammenligningen har ikke med strømavtaler som har
        rabatter. Rabattene er alltid begrenset til en kort periode og gir
        derfor ikke reelt bilde av kostnaden for avtalen. Slike avtaler er
        sortert bort for å sammenligne på like vilkår.
        <span>Vi sammenligner prisene basert på samme område</span> Norge er
        delt i 5 spotprisområder. Når vi sammenligner prisene, så er alle
        prisene i utgangspunkt i prissone 1 (Oslo), det vil si at moms (25%) og
        påslag for elsertifikater er tatt med. Kunder i Nord-Norge er fritatt
        for MVA (25%) og noen kommuner er fritatt for elsertifikater.
      </ModalContent>
    </Modal>
  );
};

export default MathModal;

const CrossWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
  padding: 15px 15px 0 0;
`;

const ModalTitle = styled.h1`
  font-size: 39px;
  line-height: 43px;
  font-family: "RiposteBold";
  color: #2d354a;
  margin: 0;
  padding: 0 70px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    padding: 0 20px;
  }
`;

const ModalContent = styled.p`
  font-size: 19px;
  line-height: 37px;
  font-family: "RiposteRegular";
  color: #2d354a;
  padding: 0 70px 60px;
  margin: 0;
  span {
    font-family: "RiposteBold";
    display: block;

    &:last-child {
      margin-top: 20px;
    }
  }

  @media (max-width: 768px) {
    padding: 0 20px 40px;
  }
`;
